
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { VfbElement } from './Element';

@Component
export default class ElementStaticExtra extends Vue {
  @Prop({ required: true })
  builderElement!: VfbElement;

  get content(): string {
    return this.builderElement.content ?? '';
  }

  set content(value: string) {
    if (typeof this.builderElement.content === 'undefined') {
      this.$set(this.builderElement, 'content', value); // if property didn't exist, it needs to be set this way, so vue makes it reactive
    }
    this.builderElement.content = value;
  }

  get tag(): string {
    return this.builderElement.tag ?? '';
  }

  set tag(value: string) {
    if (typeof this.builderElement.tag === 'undefined') {
      this.$set(this.builderElement, 'tag', value); // if property didn't exist, it needs to be set this way, so vue makes it reactive
    }
    this.builderElement.tag = value;
  }
}
